export const DispatchTripBeetrack = {
  classValidation: (row: any) => {
    if (row.invalid) {
      return 'pending';
    }
    return '';
  },
  show: 'No hay datos que mostrar',
  showIcon: './assets/icon/ico_placeholder_documentos.svg',
  paginatorAllData: true,
  columns: [
    {
      title: 'N° Viaje',
      name: 'tripId',
      type: 'string',
      editable: false,
      class: 'center',
      value: (element: any) => element.tripId
    },
    {
      title: 'N° placa',
      name: 'plateNumber',
      type: 'string',
      editable: false,
      class: 'center',
      value: (element: any) => element.plateNumber
    },
    {
      title: 'Enviado a beetrack',
      name: 'processedAmount',
      type: 'string',
      editable: false,
      class: 'center',
      value: (element: any) => element.beetrackRoute === null
        ? 'NO'
        : element.beetrackRoute.toUpperCase().includes("ERROR") ? 'NO' : 'SI'
    },
    {
      title: "Respuesta / Código de ruta de beetrack",
      name: 'beetrackRoute',
      type: 'string',
      editable: false,
      class: 'center',
      value: (element: any) => element.beetrackRoute === null
        ? element.beetrackRoute
        : element.beetrackRoute.toUpperCase().includes("ERROR") ? element.beetrackRoute.substring(5) : element.beetrackRoute
    },
  ]
}